import { render, staticRenderFns } from "./twofactor-login.vue?vue&type=template&id=c5756ca6&scoped=true"
import script from "./twofactor-login.vue?vue&type=script&lang=ts"
export * from "./twofactor-login.vue?vue&type=script&lang=ts"
import style0 from "./twofactor-login.vue?vue&type=style&index=0&id=c5756ca6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5756ca6",
  null
  
)

export default component.exports